import { c as _c } from "react/compiler-runtime";
import { PrimaryButton } from '@systemeio/ui';
import React, { FC, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { SaveIcon } from '@systemeio/ui/icons';
type Props = {
  onSave: () => void;
  disabled: boolean;
  isFetching: boolean;
  isCreate: boolean;
};
export const DigitalProductSave: FC<Props> = t0 => {
  const $ = _c(21);
  const {
    onSave,
    disabled,
    isFetching,
    isCreate
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  let t1;
  if ($[0] !== isCreate || $[1] !== onSave) {
    t1 = isCreate ? onSave : () => setOpened(true);
    $[0] = isCreate;
    $[1] = onSave;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SaveIcon />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("global.save");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== disabled || $[7] !== isFetching || $[8] !== t1 || $[9] !== t3) {
    t4 = <PrimaryButton width="large" className="w-fit" isFetching={isFetching} onClick={t1} disabled={disabled}>{t2}{t3}</PrimaryButton>;
    $[6] = disabled;
    $[7] = isFetching;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("dashboard.offer.digital_product.edit_warning");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setOpened(false);
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== onSave || $[15] !== opened || $[16] !== t5) {
    t7 = <ConfirmationModal confirmationText={t5} opened={opened} onClose={t6} onConfirm={onSave} />;
    $[14] = onSave;
    $[15] = opened;
    $[16] = t5;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t4 || $[19] !== t7) {
    t8 = <>{t4}{t7}</>;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};